import { createStyles, makeStyles } from "@material-ui/core/styles";
import illustration_error from "assets/images/illustration_error.png";
import { Button } from "ui/Button";
import React from "react";
import { useNavigate } from "react-router-dom";
import "styled-components/macro";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: "#f5f6f8",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      height: "100vh",
      width: "100%",
      justifyItems: "center",
    },
    center: {
      marginTop: "auto",
      marginBottom: "auto",
    },
    error: {
      color: "#212121",
      fontSize: 18,
      fontWeight: 900,
      textAlign: "center",
      margin: 20,
    },
    text: {
      color: "#212121",
      fontSize: 13,
      textAlign: "justify",
      display: "flex",
      justifyContent: "center",
    },
    imgcontent: {
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
      margin: 20,
    },
    img: {
      marginLeft: "auto",
      marginRight: "auto",
    },
    btn: {
      margin: 20,
      display: "flex",
      justifyContent: "center",
      color: "#fff",
    },
  })
);
export function ErrorPage() {
  const styles = useStyles();
  const navigation = useNavigate();
  return (
    <div className={styles.root}>
      <div className={styles.center}>
        <div className={styles.imgcontent}>
          <img src={illustration_error} className={styles.img} alt={`the illustration ${illustration_error}`} />
        </div>
        <div className={styles.error}>404 Error</div>
        <div className={styles.text}>
          Looks like the page you are trying to visit doesn &apos; t exist. Please check the URL and try again.
        </div>
        <div className={styles.text}>Please check the URL and try again.</div>
        <div className={styles.btn}>
          <Button
            variant="contained"
            css={`
              &.MuiButton-root {
                color: #fff;
                background: #fe8300;
              }
            `}
            onClick={() => {
              navigation(-1);
            }}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
